import { useEffect, useState } from 'react';

export const FontSizeButton = ({ disabled }: { disabled?: boolean }) => {
  const [currentSize, setCurrentSize] = useState('13');

  useEffect(() => {
    const handleSelectionChange = () => {
      const selection = window.getSelection();
      if (!selection?.rangeCount) return;

      const range = selection.getRangeAt(0);
      let node = range.startContainer;

      // If we're in a text node, get its parent
      if (node.nodeType === Node.TEXT_NODE && node.parentNode) {
        node = node.parentNode;
      }

      // Walk up the DOM tree until we find a span with font-size
      while (node && node !== document.body) {
        if (node instanceof HTMLElement && node.tagName === 'SPAN' && node.style.fontSize) {
          const size = node.style.fontSize.replace('px', '');
          setCurrentSize(size);
          return;
        }
        if (node.parentNode) {
          node = node.parentNode;
        }
      }

      setCurrentSize('13');
    };

    document.addEventListener('selectionchange', handleSelectionChange);
    return () => document.removeEventListener('selectionchange', handleSelectionChange);
  }, []);

  const handleFontSizeChange = (size: string) => {
    setCurrentSize(size);
    const selection = window.getSelection();
    if (!selection?.rangeCount) return;

    const range = selection.getRangeAt(0);
    const span = document.createElement('span');
    span.style.fontSize = `${size}px`;

    try {
      range.surroundContents(span);
    } catch (e) {
      // If surroundContents fails (e.g., selection crosses existing spans),
      // extract the text content and wrap it
      const textContent = range.extractContents();
      span.appendChild(textContent);
      range.insertNode(span);
    }

    // Restore selection
    selection.removeAllRanges();
    selection.addRange(range);
  };

  return (
    <select
      onChange={(e) => handleFontSizeChange(e.target.value)}
      value={currentSize}
      style={{
        padding: '5px 2px',
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderRadius: '4px',
        cursor: 'pointer',
      }}
      title="Font Size"
      disabled={disabled}
    >
      <option value="8">8</option>
      <option value="9">9</option>
      <option value="10">10</option>
      <option value="11">11</option>
      <option value="12">12</option>
      <option value="13">13</option>
      <option value="14">14</option>
      <option value="18">18</option>
      <option value="24">24</option>
      <option value="36">36</option>
    </select>
  );
};
